module.exports = __webpack_public_path__ + "static/media/flag_512.6d225b5d.png";